import Vue from "vue";
import { AuthorizationData, Role } from "@/features/Authentication/PlatformUserInfoService";

export class ScoreAuthorizationService {
    private authData: AuthorizationData;

    constructor() {
        this.authData = Vue.prototype.$platformUserInfoService.getUserAuthorizationData();
    }

    public canCreateScorecard(supplierID: string) {
        if (this.authData.roles.some(r => r == Role.Admin || r == Role.BusinessLineAdmin || r == Role.ScorecardOversight)) {
            return true;
        }

        if (this.authData.roles.some(r => r == Role.SupplierManager) && this.authData.supplierIDs.some(s => s == supplierID)) {
            return true;
        }

        return false;
    }

    public canPublishScorecard(supplierID: string) {
        if (this.authData.roles.some(r => r == Role.Admin || r == Role.BusinessLineAdmin || r == Role.ScorecardOversight)) {
            return true;
        }

        if (this.authData.roles.some(r => r == Role.SupplierManager) && this.authData.supplierIDs.some(s => s == supplierID)) {
            return true;
        }

        return false;
    }

    public canLockScorecard(supplierID: string) {
        console.log(this.authData);
        if (this.authData.roles.some(r => r == Role.Admin || r == Role.BusinessLineAdmin || r == Role.ScorecardOversight)) {
            return true;
        }

        if (this.authData.roles.some(r => r == Role.SupplierManager) && this.authData.supplierIDs.some(s => s == supplierID)) {
            return true;
        }

        return false;
    }
}
